import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Label, Input, ListGroup, ListGroupItem, FormGroup } from 'reactstrap';
import { InputMask } from 'primereact/inputmask';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import CompDtMoneyTransferBaseOrder from '../../Components/MoneyTransfer/CompDtMoneyTransferBaseOrder';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import { useParams, useNavigate } from "react-router-dom";

import CompCrmSegmentDropdown from '../../Components/Common/CompCrmSegmentDropdown';
import CompCrmCountryDropdown from '../../Components/Common/CompCrmCountryDropdown';
import CompCrmCityDropdown from '../../Components/Common/CompCrmCityDropdown';
import CompCrmDistrictDropdown from '../../Components/Common/CompCrmDistrictDropdown';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CloseCircleOutlined } from '@ant-design/icons';
import CurrencyFormat from 'react-currency-format';

function CompMoneyTransferBase({ referenceId }) {
    const { t } = useTranslation();
    const [componentId] = useState('compMoneyTransferBase');
    const [data, setData] = useState([]);
    const [dataMoneyTransferDetails, setDataMoneyTransferDetails] = useState(null);
    const [dataLocked, setDataLocked] = useState(true);
    const [logged, setLogged] = useState(false);
    const [seed, setSeed] = useState(0);

    const params = useParams();
    let letReferenceId = referenceId;
    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (letReferenceId && letReferenceId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/market-place/bazaar/sales-order/' + letReferenceId + '/find-and-get')
                    .then(response => {
                        setDataMoneyTransferDetails(response?.data?.payload);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, letReferenceId]);



    const [selectedItemSegment, setSelectedItemSegment] = useState('-1');
    const [segmentPersonalBlock, setSegmentPersonalBlock] = useState('d-none');
    const [segmentCompanyBlock, setSegmentCompanyBlock] = useState('d-none');
    const [formRemainIsShow, setFormRemainIsShow] = useState('d-none');
    const [title, setTitle] = useState('');

    const [contactName, setContactName] = useState('');
    const [contactSurname, setContactSurname] = useState('');
    const [contactBirthDate, setContactBirthDate] = useState('');
    const [contactIdentityNumber, setContactIdentityNumber] = useState('');
    const [contactIdentityValidation, setContactIdentityValidation] = useState(false);
    const [emailSendingAllowed, setEmailSendingAllowed] = useState(false);
    const [smsSendingAllowed, setSmsSendingAllowed] = useState(false);

    const [legalCompanyTitle, setLegalCompanyTitle] = useState('');
    const [taxOffice, setTaxOffice] = useState('');
    const [taxNumber, setTaxNumber] = useState('');

    const [note, setNote] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber,] = useState('');
    const [mobileNumber, setMobileNumber,] = useState('');
    const [selectedItemCountry, setSelectedItemCountry] = useState('-1');
    const [selectedItemCity, setSelectedItemCity] = useState('-1');
    const [selectedItemDistrict, setSelectedItemDistrict] = useState('-1');
    const [address, setAddress] = useState('');
    const [zipCode, setZipCode] = useState('');

    const onChangeCompCrmSegmentDropdown = (data) => {
        if (data?.includes("RETAIL_")) {
            setSegmentCompanyBlock('d-none');
            setSegmentPersonalBlock('mb-3');
            setFormRemainIsShow('mb-3');
        } else if (data?.includes("COMMERCIAL_")) {
            setSegmentPersonalBlock('d-none');
            setSegmentCompanyBlock('mb-3');
            setFormRemainIsShow('mb-3');
        } else {
            setSegmentCompanyBlock('d-none');
            setSegmentPersonalBlock('d-none');
            setFormRemainIsShow('d-none');
        }
        setSelectedItemSegment(data);
    }

    const onChangeCompCrmCountryDropdown = (data) => {
        setSelectedItemCountry(data);
        setSelectedItemCity(-1);
        setSelectedItemDistrict(-1);
    }

    const onChangeCompCrmCityDropdown = (data) => {
        setSelectedItemCity(data);
        setSelectedItemDistrict(-1);
    }

    const onChangeCompCrmDistrictDropdown = (data) => {
        setSelectedItemDistrict(data);
    }

    useEffect(() => {
        if (dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm !== undefined && dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm !== null) {
            let message = t('product.common-notification.loaded');
            let formattedBirthDate = "";
            if (dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.segment?.value?.includes("RETAIL_") && dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.contactBirthDate != null) {
                formattedBirthDate = moment(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.contactBirthDate).format('DD.MM.YYYY');
            }
            onChangeCompCrmSegmentDropdown(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.segment?.value);
            setContactName(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.contactName);
            setContactSurname(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.contactSurname);
            setContactBirthDate(formattedBirthDate);
            setContactIdentityNumber(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.contactIdentityNumber);
            setContactIdentityValidation(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.contactIdentityValidation);
            setLegalCompanyTitle(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.legalCompanyTitle);
            setTaxOffice(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.taxOffice);
            setTaxNumber(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.taxNumber);
            setTitle(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.title);
            setSelectedItemCountry(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.district?.city?.country?.id);
            setSelectedItemCity(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.district?.city?.id);
            setSelectedItemDistrict(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.district?.id);
            setAddress(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.address);
            setZipCode(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.zipCode);
            setPhoneNumber(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.phoneNumber);
            setMobileNumber(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.mobileNumber);
            setEmail(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.email);
            setEmailSendingAllowed(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.emailSendingAllowed);
            setSmsSendingAllowed(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.smsSendingAllowed);
            if (dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.note !== undefined && dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.note !== null) {
                setNote(dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm?.note);
            }
        }
    }, [t, logged, dataMoneyTransferDetails?.salesOrderInvoiceDetail?.buyerCrm]);


    return (
        <React.Fragment>
            <ToastContainer />

            <Row className="mt-3 mb-3">
                <Col className={"col-md-6"}>
                    <Label className="form-label fw-bold">{t('components.money-transfer.comp-money-transfer-base.form.label.invoice.title')}</Label>
                </Col>
            </Row>
            <Row className="mt-3 mb-3">
                <Col className={"col-md-6"}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.product.count')}</Label>
                    <br />
                    <Label className="form-label">{dataMoneyTransferDetails?.items?.length} {t('components.money-transfer.comp-money-transfer-base.form.label.product.piece')}</Label>
                </Col>
                <Col className={"col-md-6"}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.invoice.total')}</Label>
                    <br />
                    <Label className="form-label"><span>{'₺ '}</span><CurrencyFormat value={dataMoneyTransferDetails?.total} displayType={'text'} thousandSeparator={true} /></Label>
                </Col>
            </Row>

            <Row className="mt-3 mb-3">
                <Col className={"col-md-12"}>
                    <CompDtMoneyTransferBaseOrder items={dataMoneyTransferDetails?.items} />
                    <br />
                </Col>
            </Row>

            <Row className="mt-3 mb-3">
                <Col className={"col-md-6"}>
                    <Label className="form-label fw-bold">{t('components.money-transfer.comp-money-transfer-base.form.label.buyer-crm.title')}</Label>
                </Col>
            </Row>
            <Row className="mt-3 mb-3">
                <Col className={"col-md-6"}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.segment')}</Label>
                    <CompCrmSegmentDropdown seedValue={seed} onChange={onChangeCompCrmSegmentDropdown} selectedOption={selectedItemSegment} isDisabled={dataLocked} />
                </Col>
            </Row>
            <Row className={segmentPersonalBlock}>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.contact-first-name')}</Label>
                    <Input type="text" className="form-control" disabled={dataLocked}
                        onChange={(e) => setContactName(e.target.value)} onKeyUp={(e) => setContactName(e.target.value)} value={contactName}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.contact-first-name')} />
                </Col>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.contact-last-name')}</Label>
                    <Input type="text" className="form-control" disabled={dataLocked}
                        onChange={(e) => setContactSurname(e.target.value)} onKeyUp={(e) => setContactSurname(e.target.value)} value={contactSurname}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.contact-last-name')} />
                </Col>
            </Row>
            <Row className={segmentPersonalBlock}>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.contact-identity-number')}</Label>
                    <InputMask id="contactIdentityNumber" className={"form-control"} disabled={dataLocked} mask="99999999999" placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.contact-identity-number')} onChange={e => setContactIdentityNumber(e.target.value)} onKeyUp={e => setContactIdentityNumber(e.target.value)} value={contactIdentityNumber} />
                </Col>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.contact-birth-date')}</Label>
                    <InputMask id="contactBirthDate" className={"form-control"} disabled={dataLocked} mask="99.99.9999" placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.contact-birth-date')} onChange={e => setContactBirthDate(e.target.value)} onKeyUp={e => setContactBirthDate(e.target.value)} value={contactBirthDate} />
                </Col>
            </Row>
            <Row className={segmentPersonalBlock}>
                <Col className={"col-md-6"}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.identity-verification-status')}</Label>
                </Col>
                <Col className={"col-md-6"}>
                    <div className={contactIdentityValidation === true ? "d-none" : "hstack gap-2 justify-content-end"}>

                        <span >
                            <span className='text-danger'><CloseCircleOutlined /></span> {t('components.money-transfer.comp-money-transfer-base.form.label.identity-verification-status.unverified')}
                        </span>                                                       </div>
                    <div className={contactIdentityValidation === true ? "hstack gap-2 justify-content-end" : "d-none"}>
                        <span >
                            <span className='text-success'><CheckCircleOutlined /></span> {t('components.money-transfer.comp-money-transfer-base.form.label.identity-verification-status.verified')}
                        </span>
                    </div>
                </Col>
            </Row>
            <Row className={segmentCompanyBlock}>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.legal-company-title')}</Label>
                    <Input type="text" className="form-control" disabled={dataLocked}
                        onChange={(e) => setLegalCompanyTitle(e.target.value)} onKeyUp={(e) => setLegalCompanyTitle(e.target.value)} value={legalCompanyTitle}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.legal-company-title')} />
                </Col>
                <Col lg={6}>

                </Col>
            </Row>
            <Row className={segmentCompanyBlock}>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.tax-office')}</Label>
                    <Input type="text" className="form-control"
                        onChange={(e) => setTaxOffice(e.target.value)} onKeyUp={(e) => setTaxOffice(e.target.value)} value={taxOffice} disabled={dataLocked}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.tax-office')} />
                </Col>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.tax-number')}</Label>
                    <Input type="text" className="form-control"
                        onChange={(e) => setTaxNumber(e.target.value)} onKeyUp={(e) => setTaxNumber(e.target.value)} value={taxNumber} disabled={dataLocked}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.tax-number')} />
                </Col>
            </Row>
            <Row className={formRemainIsShow}>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.country')}</Label>
                    <CompCrmCountryDropdown key={seed} onChange={onChangeCompCrmCountryDropdown} selectedOption={selectedItemCountry} isDisabled={dataLocked} />
                </Col>
                <Col lg={6}>
                    <Label htmlFor="choices-status-input" className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.city')}</Label>
                    <CompCrmCityDropdown key={seed} onChange={onChangeCompCrmCityDropdown} cascadeOption={selectedItemCountry} selectedOption={selectedItemCity} isDisabled={dataLocked} />
                </Col>
            </Row>
            <Row className={formRemainIsShow}>
                <Col lg={6}>
                    <Label htmlFor="datepicker-deadline-input" className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.district')}</Label>
                    <CompCrmDistrictDropdown key={seed} onChange={onChangeCompCrmDistrictDropdown} cascadeOption={selectedItemCity} selectedOption={selectedItemDistrict} isDisabled={dataLocked} />
                </Col>
                <Col lg={6}>
                    <Label htmlFor="datepicker-deadline-input" className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.zip-code')}</Label>
                    <Input type="text" className="form-control" disabled={dataLocked}
                        onChange={(e) => setZipCode(e.target.value)} onKeyUp={(e) => setZipCode(e.target.value)} defaultValue={zipCode}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.zip-code')} />
                </Col>

            </Row>
            <Row className={formRemainIsShow}>
                <Col lg={12}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.address')}</Label>
                    <Input type="textarea" className="form-control" rows={1} disabled={dataLocked}
                        onChange={(e) => setAddress(e.target.value)} onKeyUp={(e) => setAddress(e.target.value)} defaultValue={address}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.address')} />
                </Col>
            </Row>
            <Row className={formRemainIsShow}>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.mobile-number')}</Label>
                    <InputMask id="mobileNumber" className={"form-control"} mask="(599) 999-9999" placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.mobile-number')} onChange={e => setMobileNumber(e.target.value)} onKeyUp={e => setMobileNumber(e.target.value)} value={mobileNumber} disabled={dataLocked} />
                </Col>
                <Col lg={6}>
                    <Label className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.phone-number')}</Label>
                    <InputMask id="phoneNumber" className={"form-control"} mask="(999) 999-9999" placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.phone-number')} onChange={e => setPhoneNumber(e.target.value)} onKeyUp={e => setPhoneNumber(e.target.value)} value={phoneNumber} disabled={dataLocked} />
                </Col>
            </Row>
            <Row className={formRemainIsShow}>
                <Col lg={6}>
                    <Label htmlFor="choices-status-input" className="form-label">{t('components.money-transfer.comp-money-transfer-base.form.label.email')}</Label>
                    <Input type="text" className="form-control"
                        onChange={(e) => setEmail(e.target.value)} onKeyUp={(e) => setEmail(e.target.value)} defaultValue={email} disabled={dataLocked}
                        placeholder={t('components.money-transfer.comp-money-transfer-base.form.placeholder.email')} />
                </Col>
                <Col lg={6}>

                </Col>
            </Row>
        </React.Fragment>
    );
}
export default CompMoneyTransferBase;